<template>
  <v-row justify="center">
    <v-dialog
      :value="dialog"
      @input="(v) => !v && $emit('close')"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="fecharModal()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Plano Bimestral</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-row>
          <v-col class="position-relative">
            <v-overlay :value="loading" absolute>
              <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
            </v-overlay>

            <iframe
              v-if="dialog"
              :key="pdfKey"
              :src="pdf"
              frameborder="0"
              style="min-height: 100vh; width: 100%"
              @load="onPdfLoad"
            >
            </iframe>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      pdfKey: 0,
    };
  },
  props: {
    dialog: {
      type: Boolean,
    },
    pdf: {
      value: File,
    },
  },
  watch: {
    dialog(newVal) {
      if (newVal) {
        this.loading = true;
        this.pdfKey++;
      }
    },
    pdf(newVal) {
      if (newVal && this.dialog) {
        this.loading = true;
        this.pdfKey++;
      }
    },
  },
  methods: {
    onPdfLoad() {
      setTimeout(() => {
        this.loading = false;
      }, 800);
    },
    esconderModal() {
      this.$emit("update", true);
    },
    fecharModal() {
      this.$emit("close");
      this.esconderModal();
    },
  },
};
</script>

<style scoped>
.position-relative {
  position: relative;
}
</style>
